import * as React from 'react';
import { connect } from "react-redux";
import { ITmdState } from '../../reducers';
import { RequestState } from "../../enumerations/RequestState";
import { bindActionCreators } from "redux";
import { match } from 'react-router';
import { DefaultLayout, RestrictedLayout, INavItem, UnrestrictedLayout } from "../../components/layouts/index";
import { FontAwesomeIcon, FontAwesomeIcons } from '../../constants/fontAwesomeIcons';
import { IRegistrationFormState } from "../../reducers/reactReduxForms/index";
import { IRegistrationElement, RegistrationFormComponent, IRegistrationGrid } from "../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent, getFormProperty, getFormPropertyLabel } from "../../helpers/formHelper";
import { TextFormInput, GenericFormGroup, RadioButtonSetFormInput, SelectFormInput, DatePickerFormInput, DatePickerPartialFormInput, MaskedFormInput, NumberFormInput, CheckboxFormInput, StaticFormInput, GenericMultiFormGroup, ValidationMessage } from "../../components/form/index";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveError, renderRegistrationFormSaveBlock } from "../../helpers/alert";

import Alert from 'react-s-alert';
import Modal from 'react-responsive-modal';
import { NotificationAlert, MessageModal } from "../../components/common/index";
import { routerActions } from 'react-router-redux';
import { Form, Control, actions, Errors } from "react-redux-form";
import { IWebsiteSettingReduxFormState, initialWebsiteSettingFormState } from "../../reducers/reactReduxForms/websiteSettingsForm";

import * as Dtos from '../../dtos/Tmd.dtos';
import * as WebsiteSettingsActions from '../../actions/websiteSettings';
import { SettingsSubMenu } from '../../helpers/subMenuHelper';

interface IWebsiteSettingsPageProps {

    form: Dtos.WebsiteSetting & IRegistrationFormState;
    reduxFormState: IWebsiteSettingReduxFormState;

    websiteSetting: Dtos.WebsiteSetting;

    loadingSettings: boolean;
    loadingSettingsSuccess: boolean;
    loadingSettingsFailure: boolean;

    savingSettings: boolean;
    savingSettingsSuccess: boolean;
    savingSettingsFailure: boolean;

    permissions?: Dtos.PersonnelTmdPermissions[];
}

interface IWebsiteSettingsPageActions {
    load: WebsiteSettingsActions.IWebsiteSettingsLoadActionCreator;
    save: WebsiteSettingsActions.IWebsiteSettingsSetActionCreator;
    clear: WebsiteSettingsActions.IWebsiteSettingsClearActionCreator;

    
    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;
}

type WebsiteSettingsPageProps = IWebsiteSettingsPageProps & IWebsiteSettingsPageActions;

const formName: string = "WebsiteSetting";
const reduxFormName: string = "reduxForms.websiteSetting";

class WebsiteSettingsPage extends React.Component<WebsiteSettingsPageProps, any> {

    constructor(props) {
        super(props);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
    }

    componentWillMount() {
    }

    componentDidMount() {
        const {
            load
        } = this.props;

        load();
    }

    componentWillReceiveProps(nextProps: IWebsiteSettingsPageProps) {
    }

    componentDidUpdate(prevProps: IWebsiteSettingsPageProps, prevState) {
        console.log('WebsiteSettingsPage.componentDidUpdate', this.props.websiteSetting)
        
        const {
            websiteSetting,
            loadForm,
            loadingSettings,
            loadingSettingsSuccess,
            navigateReplace,
            form,
            reduxFormState,
            navigate,
            savingSettings,
            savingSettingsFailure,
            savingSettingsSuccess
        } = this.props;

        if (!loadingSettings && prevProps.loadingSettings) {
            if (loadingSettingsSuccess) {
                this.loadForm();
            }
            else {

            }
        }

        if (!savingSettings && prevProps.savingSettings) {
            if (savingSettingsSuccess) {
                    Alert.success(<NotificationAlert
                        alertContent={renderRegistrationFormSaveSuccess()}
                        icon={FontAwesomeIcons.Solid.CHECK}
                    />);

                if (form.saveAndReturn) {

                    navigate("/home" )
                }
                else if (!form.saveAndReturn) {
                    this.loadForm();
                }
            }
            else {
                Alert.error(
                    <NotificationAlert
                        alertContent={renderRegistrationFormSaveError()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );

            }
            
        }
        
    }

    componentWillUpdate(nextProps: IWebsiteSettingsPageProps) {
    }

    componentWillUnmount() {
       
        const {
            resetForm,
            loadForm
        } = this.props
        
        loadForm(reduxFormName, initialWebsiteSettingFormState);
        resetForm(reduxFormName);
    }

    render() {
        return <RestrictedLayout
            subMenuItems={SettingsSubMenu(this.props.permissions)}
            loading={false}
        >
            {this.renderContent()}
        </RestrictedLayout>
    }

    renderContent() {
        const {
            form,
            changeForm
        } = this.props;

        const formDisabled: boolean = false;


        const formComponents: { [index: string]: RegistrationFormComponent } = {
            performanceStatusHeading: {
                type: RegistrationComponent.RegistrationElement,
                component: <div className="row p-4 border border-top-0 border-left-0 border-right-0">
                    <h3>Settings</h3>
                </div>
            },
            message: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
                inputLabel: "Message to show on home screen"
            },
            showMessage: {
                type: RegistrationComponent.RegistrationControl,
                inputType: CheckboxFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    label: "Show message on homescreen"
                },
                inputLabel: " ",
            },
        };

        return <div>
            <Form model={reduxFormName}
                onSubmit={(val, event) => this.handleOnSubmit(val)}
                onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
            >
                {
                    renderFormControls(form, "websiteSetting", formComponents, [], [], [], changeForm)
                }
                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled}
                        onClick={
                            () => {
                                this.props.changeForm(reduxFormName + ".saveAndReturn", false);
                            }
                        }
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2" > Cancel </button>
                </div>
            </Form>
        </div>;
    }

    handleOnSubmit(data: Dtos.WebsiteSetting) {
        const {
            save
        } = this.props;

        if (data) {
            let changes: Dtos.WebsiteSetting = {} as Dtos.WebsiteSetting;
            save(Object.assign({ ...data }, changes));
        }
    }


    handleOnSubmitFailed(data: Dtos.WebsiteSetting) {
        Alert.error(<NotificationAlert
            minWidth={500}
            alertContent={renderRegistrationFormSaveBlock()}
            icon={FontAwesomeIcons.Solid.BAN}
        />);
    }

    onCancel() {
        const {
            navigate
        } = this.props;

        navigate("/registration");
    }

    loadForm() {
        const {
            loadForm,
            websiteSetting
        } = this.props

        let extraData: Dtos.WebsiteSetting = {} as Dtos.WebsiteSetting;

        loadForm(reduxFormName, Object.assign({ ...websiteSetting }, extraData));
    }

}

const mapStateToProps = (state: ITmdState, ownProps: WebsiteSettingsPageProps): IWebsiteSettingsPageProps => {
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {
        form: state.reduxForms.websiteSetting,
        reduxFormState: state.reduxForms.formState.websiteSetting,

        websiteSetting: !(state.websiteSettings.data instanceof Array) ? state.websiteSettings.data : undefined,
        
        loadingSettings: state.websiteSettings.loadState && state.websiteSettings.loadState.status == RequestState.Pending,
        loadingSettingsSuccess: state.websiteSettings.loadState && state.websiteSettings.loadState.status == RequestState.Success,
        loadingSettingsFailure: state.websiteSettings.loadState && state.websiteSettings.loadState.status == RequestState.Failure,
    
        savingSettings: state.websiteSettings.saveState && state.websiteSettings.saveState.status == RequestState.Pending,
        savingSettingsSuccess: state.websiteSettings.saveState && state.websiteSettings.saveState.status == RequestState.Success,
        savingSettingsFailure: state.websiteSettings.saveState && state.websiteSettings.saveState.status == RequestState.Failure,

        permissions: permissions,
    };
};

const mapDispatchToProps = (dispatch): IWebsiteSettingsPageActions => {
    return {
        load: bindActionCreators(WebsiteSettingsActions.LoadWebsiteSettings, dispatch),
        save: bindActionCreators(WebsiteSettingsActions.SetWebsiteSettings, dispatch),
        clear: bindActionCreators(WebsiteSettingsActions.Clear, dispatch),

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    }
};

export default
    connect(mapStateToProps, mapDispatchToProps)(WebsiteSettingsPage);